export default "__VITE_ASSET__KSC1vXO0__"